var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8411 0H1.15894C0.518438 0 0 0.518438 0 1.15894V19.8411C0 20.4816 0.518438 21 1.15894 21H11.2166V12.8678H8.47875V9.69938H11.2166V7.35919C11.2166 4.64756 12.873 3.17231 15.2933 3.17231C16.4522 3.17231 17.4484 3.25631 17.7384 3.29569V6.13069H16.0584C14.7459 6.13069 14.49 6.76069 14.49 7.67944V9.70069H17.6269L17.22 12.8769H14.49V21H19.8411C20.4816 21 21 20.4816 21 19.8411V1.15894C21 0.518438 20.4816 0 19.8411 0Z",
    fill: "#3B5998"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.028342d0.svg";
export { ForwardRef as ReactComponent };